/**
 * ARCHIVO GENERADO por scripts/generar-version.js. No editarlo a mano:
 * se reescribe en cada compilación.
 *
 * Para subir la versión: npm version patch (o minor, o major).
 */
export const VERSION = {
  /** El número que se dice en voz alta. Sale del package.json. */
  numero: '1.0.109',
  /** Commit exacto que se compiló. Vacío si se compiló sin repositorio. */
  commit: '24b24e0f',
  /** Cuándo se compiló, en UTC. */
  compilado: '2026-10-31T15:22:10.125Z',
} as const;
